(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var nav = document.querySelector('.brands-alpha-nav');
    if (!nav) return;

    var navLinks = Array.prototype.slice.call(nav.querySelectorAll('a.brands-alpha-nav__letter'));
    var groups = Array.prototype.slice.call(document.querySelectorAll('.brand-letter-group'));

    if (!navLinks.length || !groups.length) return;

    function getHeaderHeight() {
      return (
        parseInt(getComputedStyle(document.documentElement).getPropertyValue('--m-header-height')) || 0
      );
    }

    function getTriggerLine() {
      var navHeight = nav.offsetHeight || 0;
      return getHeaderHeight() + navHeight + 24;
    }

    var activeLetter = null;

    function setActive(letter) {
      if (letter === activeLetter) return;
      activeLetter = letter;

      navLinks.forEach(function (link) {
        var isActive = link.dataset.letter === letter;
        link.classList.toggle('is-active', isActive);
        if (isActive) {
          // keep the active pill visible in the horizontally-scrolling nav on mobile
          link.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        }
      });
    }

    var ticking = false;

    function updateActiveLetter() {
      ticking = false;
      var triggerLine = getTriggerLine();
      var current = null;

      // Pick the last group whose top has crossed the trigger line.
      for (var i = 0; i < groups.length; i++) {
        var rect = groups[i].getBoundingClientRect();
        if (rect.top <= triggerLine) {
          current = groups[i];
        } else {
          break;
        }
      }

      if (!current) {
        current = groups[0];
      }

      var letter = current.id.replace('brand-letter-', '');
      setActive(decodeURIComponent(letter));
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(updateActiveLetter);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    // Smooth scroll on click; CSS scroll-margin-top handles the sticky offset.
    navLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var targetId = link.getAttribute('href').slice(1);
        var target = document.getElementById(decodeURIComponent(targetId));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', '#' + targetId);
          setActive(link.dataset.letter);
        }
      });
    });

    updateActiveLetter();
  });
})();